import { translate } from "../../../../intl";
import {
  Status,
  StatusEnum,
  StatusKey,
  StatusString,
  StatusTypes,
} from "../../../../types/statusTypes";
import { isDateExpired } from "../../../../utils";

type WorkOrder = {
  work_order_number: string;
  work_order_status: StatusKey;
  work_order_type: string;
  due_date: string;
};

const effect = {
  [StatusEnum.CRITICAL]: 3,
  [StatusEnum.DEGRADED]: 2,
  [StatusEnum.HEALTHY]: 1,
  [StatusEnum.NO_DATA]: "",
  [StatusEnum.MITIGATED]: "",
};

export const getWorkOrderOrSensorInfoByStatus = (
  status: keyof typeof StatusEnum,
): { color: "RED" | "ORANGE" | "GREEN" | "GRAY"; statusCode: Status } => {
  switch (status) {
    case StatusEnum.CRITICAL:
      return { color: "RED", statusCode: StatusTypes[StatusString[status]] };
    case StatusEnum.DEGRADED:
      return { color: "ORANGE", statusCode: StatusTypes[StatusString[status]] };
    case StatusEnum.HEALTHY:
      return { color: "GREEN", statusCode: StatusTypes[StatusString[status]] };
    default:
      return { color: "GRAY", statusCode: StatusTypes.noData };
  }
};

export const getWOStripeContent = (wo: WorkOrder) => {
  if (wo.work_order_type === "Corrective")
    return `${wo.work_order_type} - ${effect[wo.work_order_status]}`;

  return `${wo.work_order_type} - ${
    isDateExpired(wo.due_date)
      ? translate("tagsPage.woLate")
      : translate("tagsPage.woOnTime")
  }`;
};
